/*
  This function should later be able to validate multiple characteristics
  of a file to ensure it is valid. If we find that it wont be needed, even
  for logging, for example, we can remove this file.
*/

export const validateAvatarImageFile = (file: File) => {
  const FILE_LIMIT_IN_BYTES = 4194304 // 5mb

  if (file.size > FILE_LIMIT_IN_BYTES) {
    // eslint-disable-next-line no-console
    console.info('[validateAvatarImageFile] IMAGE_SIZE_TOO_BIG')
  }
}
